// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3I9S1","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3ASav"};